export enum DomainType {
  EMUDHRA = 'EMUDHRA',
  ABCL = 'ABCL',
  DOQFY = 'DOQFY',
}
